(() => {
  const BUTTON_CLASS = 'instafeed-scroll-to-box-button';
  const BUTTON_TEXT = 'Sprawdź produkty';
  const SCROLL_OFFSET = 96; // two fixed elements (combined height)
  const ELEMENT_NAME = 'video_interaction';
  const PRODUCT_ELEMENT_NAME = 'product_interaction';
  const COLLECTION_ELEMENT_NAME = 'collection_interaction';
  const INTERACTION_TYPE = 'click';

  const sendDataLayerEvent = (payload, label) => {
    if (typeof dataLayerPromise !== 'function') return Promise.resolve();

    try {
      const result = dataLayerPromise(payload);

      if (result && typeof result.then === 'function') {
        return result.catch((error) => console.error(`${label} error`, error));
      }

      return Promise.resolve(result);
    } catch (error) {
      console.error(`${label} error`, error);
      return Promise.resolve();
    }
  };

  const findScrollContainer = (element) => {
    let node = element.parentElement;
    while (node && node !== document.body) {
      const styles = window.getComputedStyle(node);
      const overflowY = styles.overflowY;
      const canScroll = (overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight;
      if (canScroll) return node;
      node = node.parentElement;
    }

    return document.scrollingElement || document.documentElement;
  };

  const getSectionContext = () => {
    const body = document.body;
    if (body.classList.contains('template--product.suplementy') || body.classList.contains('template--product'))
      return 'product_page';
    if (body.classList.contains('template--collection')) return 'collection_page';
    return 'homepage';
  };

  const getSlideUsername = (slide) => {
    const el = slide.querySelector('.tagged-username-overlay');
    return el?.textContent?.trim() || null;
  };

  const sendInteractionEvent = (slide) => {
    const elementValue = getSlideUsername(slide);
    const payload = {
      event: 'instafeed_interaction',
      section: getSectionContext(),
      element: ELEMENT_NAME,
      element_value: elementValue,
      interaction_type: INTERACTION_TYPE,
    };

    return sendDataLayerEvent(payload, 'instafeed event');
  };

  const getTaggedProductName = (anchor) => {
    const container = anchor.closest('.tagged-products');
    const nameEl = container?.querySelector('.instafeed-product-name');
    return nameEl?.textContent?.trim() || null;
  };

  const isCollectionLink = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      return url.pathname.includes('/collections');
    } catch (error) {
      return href.includes('/collections');
    }
  };

  const sendProductInteractionEvent = (anchor) => {
    const productName = getTaggedProductName(anchor);
    const href = anchor?.href || '';
    const elementName = isCollectionLink(href) ? COLLECTION_ELEMENT_NAME : PRODUCT_ELEMENT_NAME;
    const payload = {
      event: 'instafeed_interaction',
      section: getSectionContext(),
      element: elementName,
      element_value: productName || href,
      interaction_type: INTERACTION_TYPE,
    };

    return sendDataLayerEvent(payload, 'instafeed product event');
  };

  const addScrollButtonToModal = (modal) => {
    if (!modal || modal.querySelector(`.${BUTTON_CLASS}`)) return;

    const boxContent = modal.querySelector('.box-content');
    if (!boxContent) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = BUTTON_CLASS;
    button.textContent = BUTTON_TEXT;

    button.addEventListener('click', (event) => {
      event.stopPropagation();
      const scrollContainer = findScrollContainer(boxContent);
      const rect = boxContent.getBoundingClientRect();
      const currentScrollTop =
        scrollContainer === document.scrollingElement || scrollContainer === document.documentElement
          ? window.pageYOffset
          : scrollContainer.scrollTop;

      const target = rect.top + currentScrollTop - SCROLL_OFFSET;

      if (scrollContainer === document.scrollingElement || scrollContainer === document.documentElement) {
        window.scrollTo({ top: target, behavior: 'smooth' });
      } else {
        scrollContainer.scrollTo({ top: target, behavior: 'smooth' });
      }
    });

    const container = modal.querySelector('.lightbox-instagram .instafeed-post-image') || modal;
    container.prepend(button);
  };

  const addButtonsToAllModals = () => {
    document.querySelectorAll('.instafeed-lightbox').forEach((modal) => addScrollButtonToModal(modal));
  };

  const getModalForSlide = (slide) => {
    const instafeedRoot = slide.closest('.instafeed-shopify, #insta-feed');
    const slides = instafeedRoot
      ? Array.from(instafeedRoot.querySelectorAll('.instafeed-new-layout-item'))
      : Array.from(document.querySelectorAll('.instafeed-new-layout-item'));

    const slideIndex = slides.indexOf(slide);
    if (slideIndex === -1) return null;

    const scopedModals = instafeedRoot
      ? instafeedRoot.querySelectorAll('.instafeed-modals-wrapper .instafeed-lightbox')
      : null;

    if (scopedModals && scopedModals[slideIndex]) {
      return scopedModals[slideIndex];
    }

    const globalModals = document.querySelectorAll('.instafeed-modals-wrapper .instafeed-lightbox');
    return globalModals[slideIndex] || null;
  };

  const handleDocumentClick = (event) => {
    const productLink = event.target.closest('.tagged-products a');
    if (productLink) {
      event.preventDefault();
      const href = productLink.href;
      const eventPromise = sendProductInteractionEvent(productLink);

      if (eventPromise && typeof eventPromise.then === 'function') {
        eventPromise.finally(() => {
          continueLinkClickEvent(event, href);
        });
      } else {
        continueLinkClickEvent(event, href);
      }
    }

    const slide = event.target.closest('.instafeed-new-layout-item');
    if (!slide) return;
    sendInteractionEvent(slide);

    const modal = getModalForSlide(slide);
    if (!modal) return;

    addScrollButtonToModal(modal);
  };

  const attachWhenInstafeedReady = () => {
    let initialized = false;

    const tryInit = () => {
      if (initialized) return true;
      if (!document.querySelector('.instafeed-new-layout-item')) return false;

      document.addEventListener('click', handleDocumentClick, true);
      addButtonsToAllModals();
      initialized = true;
      return true;
    };

    if (tryInit()) return;

    const observer = new MutationObserver(() => {
      if (tryInit()) observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachWhenInstafeedReady);
  } else {
    attachWhenInstafeedReady();
  }
})();
